import { storeSet } from '../store';
import logMsgWithSentry from '../helpers/logMsgWithSentry';

export class NetworkService {
  static logApiError = (endpoint, status = 0, resp = {}) => {
    if (status === 500) {
      logMsgWithSentry(endpoint, status, resp);
    } else if (status === 403) {
      storeSet('token', '');
      const { pathname } = window.location;
      if (!['/login', '/registration', '/reset-password'].includes(pathname)) {
        window.location.replace('/login');
      }
    }
  };

  static post = (url, body, callback, errorCallback, queryParams) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&') {
        url = url.substring(0, url.length - 1);
      }
    }

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.json(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static postMultiPart = (url, body, callback, errorCallback, queryParams) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&')
        url = url.substring(0, url.length - 1);
    }

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        // 'Content-Type': 'multipart/form-data',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: body,
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.json(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static postBlob = (url, body, callback, errorCallback, queryParams) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&')
        url = url.substring(0, url.length - 1);
    }

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.blob(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static unauthorizedPost = (
    url,
    body,
    callback,
    errorCallback,
    queryParams
  ) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&')
        url = url.substring(0, url.length - 1);
    }

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.json(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static put = (url, body, callback, errorCallback, queryParams = null) => {
    if (queryParams) {
      url += '?';

      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&')
        url = url.substring(0, url.length - 1);
    }

    fetch(url, {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.json(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static isNotBlank(value) {
    return value !== null && value !== undefined && value !== '';
  }

  static get = (url, callback, errorCallback, queryParams = null) => {
    if (queryParams) {
      url += '?';

      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&')
        url = url.substring(0, url.length - 1);
    }

    fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      //signal: AbortSignal.timeout(5000)
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.json(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => {
        errorCallback(err);
      });
  };

  static getBlob = (url, callback, errorCallback, queryParams) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) param += '&';

          url += param;
        }
      }

      if (url.charAt(url.length) === '&')
        url = url.substring(0, url.length - 1);
    }

    fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        return { response: await response.blob(), status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static delete = (url, callback, errorCallback) => {
    fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        let responseData = null;
        if (response.status !== 204) {
          try {
            responseData = await response.json();
          } catch (error) {
            console.warn(
              'Errore durante il parsing JSON della risposta DELETE (potrebbe non esserci un body):',
              error
            );
          }
        }
        return { response: responseData, status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static patch = (url, body, callback, errorCallback, queryParams = null) => {
    if (queryParams) {
      const params = new URLSearchParams();
      for (const [key, value] of queryParams) {
        params.append(key, value);
      }
      url += `?${params.toString()}`;
    }

    const formData = new FormData();
    for (const key in body) {
      formData.append(key, body[key]);
    }

    fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: formData,
    })
      .then(async (response) => {
        const status = response.status;
        this.logApiError(url, status);
        let responseData = null;
        if (response.status !== 204) {
          try {
            responseData = await response.json();
          } catch (error) {
            console.warn('Risposta non JSON:', error);
            responseData = null;
          }
        }
        return { response: responseData, status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static putMultiPart = (url, body, callback, errorCallback, queryParams) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) {
            param += '&';
          }

          url += param;
        }
      }

      if (url.charAt(url.length - 1) === '&') {
        url = url.substring(0, url.length - 1);
      }
    }

    fetch(url, {
      method: 'PUT',
      mode: 'cors',
      headers: {
        // 'Content-Type': 'multipart/form-data',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: body,
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        let responseData = null;
        try {
          responseData = await response.json();
        } catch (error) {
          if (status >= 200 && status < 300 && status !== 204) {
            console.warn('Response was not JSON:', response);
          }
        }
        return { response: responseData, status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };

  static patchMultiPart = (url, body, callback, errorCallback, queryParams) => {
    if (queryParams) {
      url += '?';
      for (let i = 0; i < queryParams.length; i++) {
        if (
          queryParams[i] &&
          this.isNotBlank(queryParams[i][0]) &&
          this.isNotBlank(queryParams[i][1])
        ) {
          let param = queryParams[i][0] + '=' + queryParams[i][1];

          if (i !== queryParams.length - 1) {
            param += '&';
          }

          url += param;
        }
      }

      if (url.charAt(url.length - 1) === '&') {
        url = url.substring(0, url.length - 1);
      }
    }

    fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        // 'Content-Type': 'multipart/form-data',
        Authorization: 'Token ' + localStorage.getItem('token'),
      },
      body: body,
    })
      .then(async (response) => {
        let status = response.status;
        this.logApiError(url, status);
        let responseData = null;
        try {
          responseData = await response.json();
        } catch (error) {
          if (status >= 200 && status < 300 && status !== 204) {
            console.warn('Response was not JSON:', response);
          }
        }
        return { response: responseData, status: status };
      })
      .then((data) => {
        if (data.status >= 400 && data.status <= 599) {
          errorCallback(data.response);
          this.logApiError(url, data.status, data.response);
        } else {
          callback(data.response);
        }
      })
      .catch((err) => errorCallback(err));
  };
}
